import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import Button from 'shared/modules/common/components/atoms/Button';

const EditUserPhoneNewPhoneOTPSent = (props: {
  phoneNumber: string;
  onSubmit: () => void;
}) => {
  return (
    <>
      <View style={style.root}>
        <Text style={style.textTitle}>
          新しい携帯電話番号に認証コードを送信しました
        </Text>
        <View style={style.spacer} />
        <Text>
          {props.phoneNumber}
          に送信された4桁の認証コードを確認してください。
        </Text>
        <View style={style.spacer} />
      </View>
      <Button
        title="次へ"
        onPress={() => props.onSubmit()}
        style={style.nextButton}
        id="edit-user-phone-next-button"
      />
    </>
  );
};

const style = StyleSheet.create({
  root: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  textTitle: {
    fontSize: 20,
    fontWeight: '600',
    alignSelf: 'center',
  },
  spacer: {
    marginBottom: 24,
  },
  nextButton: {
    alignSelf: 'center',
  },
});

export default EditUserPhoneNewPhoneOTPSent;
